export const useIsWhiteLabeled = () => {
  return !['demo.theopenpantry.com', 'app.theopenpantry.com'].includes(window.location.hostname);
};
